// extracted by mini-css-extract-plugin
export default {"fullWidth":"Ym-z","image":"Zm-z","lazyLoadPicture":"_m-z","lazyLoadSpinner":"an-z","lazyLoadSpin":"bn-z","lazyLoadImage":"cn-z","hasStyledAspectRatio":"dn-z"};